import { createFileRoute } from "@tanstack/react-router"

import { VehicleCreateRouteComponent } from "@/routes/_authenticated/account/vehicles/create"
import { getStr } from "@/utilities/etc"

export const Route = createFileRoute(
  "/qr/$qrLookupID/_authenticated/account/vehicles/create"
)({
  validateSearch: (search: Record<string, unknown>) => ({
    redirect: getStr(search.redirect),
    plate: getStr(search.plate),
  }),
  component: RouteComponent,
})

function RouteComponent() {
  const { redirect, plate } = Route.useSearch()
  return <VehicleCreateRouteComponent redirect={redirect} plate={plate} />
}
